import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import SnapIfNeededOverlayOp from '../overlay/snap/SnapIfNeededOverlayOp';
import OverlayOp from '../overlay/OverlayOp';
var UnionOp = /*#__PURE__*/function () {
  function UnionOp() {
    _classCallCheck(this, UnionOp);
  }
  _createClass(UnionOp, [{
    key: "getClass",
    value: function getClass() {
      return UnionOp;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "union",
    value: function union(g, other) {
      if (g.isEmpty() || other.isEmpty()) {
        if (g.isEmpty() && other.isEmpty()) return OverlayOp.createEmptyResult(OverlayOp.UNION, g, other, g.getFactory());
        if (g.isEmpty()) return other.copy();
        if (other.isEmpty()) return g.copy();
      }
      g.checkNotGeometryCollection(g);
      g.checkNotGeometryCollection(other);
      return SnapIfNeededOverlayOp.overlayOp(g, other, OverlayOp.UNION);
    }
  }]);
  return UnionOp;
}();
export { UnionOp as default };